import { createAction } from 'redux-actions';
import { HERO_ACTIONS } from './heroActions';
import { log } from "../../Helpers/logger";

export const CHARACTER_ACTIONS = {
  CREATE: 'character/create',
  UPDATE: 'character/update',
  DELETE: 'character/delete'
};

export const characterActions = {
  createCharacter: createAction(CHARACTER_ACTIONS.CREATE, (characterData) => ({
    ...characterData,
    createdAt: new Date().toISOString(),
    level: 1,
    experience: 0,
    gold: 100,
    inventory: []
  })),

  updateCharacter: createAction(CHARACTER_ACTIONS.UPDATE, (characterData) => ({
    ...characterData,
    updatedAt: new Date().toISOString()
  })),

  deleteCharacter: createAction(CHARACTER_ACTIONS.DELETE)
};

// Plain async helper (formerly thunk). Normalises stats, persists to
// localStorage, dispatches create/update + SET_HERO. Caller awaits the
// resolved character.
export const saveCharacter = async (dispatch, characterData) => {
  log.reducer.log('Saving character data:', characterData);

  const character = {
    ...characterData,
    updatedAt: new Date().toISOString(),
    stats: {
      strength: Math.max(1, parseInt(characterData.stats?.strength || 10, 10)),
      intelligence: Math.max(1, parseInt(characterData.stats?.intelligence || 10, 10)),
      dexterity: Math.max(1, parseInt(characterData.stats?.dexterity || 10, 10)),
      vitality: Math.max(1, parseInt(characterData.stats?.vitality || 10, 10)),
      maxHealth: Math.max(1, parseInt(characterData.stats?.maxHealth || 50, 10)),
      health: Math.min(
        Math.max(1, parseInt(characterData.stats?.health || 50, 10)),
        Math.max(1, parseInt(characterData.stats?.maxHealth || 50, 10))
      ),
      mana: Math.max(0, parseInt(characterData.stats?.mana || 30, 10)),
      maxMana: Math.max(0, parseInt(characterData.stats?.maxMana || 30, 10))
    },
    level: Math.max(1, parseInt(characterData.level || 1, 10)),
    xp: Math.max(0, parseInt(characterData.xp || 0, 10)),
    gold: Math.max(0, parseInt(characterData.gold || 100, 10)),
    position: characterData.position || { mapId: 'map1', x: 0, y: 1 },
    inventory: Array.isArray(characterData.inventory) ? characterData.inventory : [],
    classType: characterData.classType || 'WARRIOR',
    gender: characterData.gender || 'male',
    name: characterData.name || 'Hero'
  };

  if (!character.id) {
    character.id = `hero_${Date.now()}`;
    character.createdAt = new Date().toISOString();
  }

  localStorage.setItem('character', JSON.stringify(character));

  if (characterData.id) {
    dispatch(characterActions.updateCharacter(character));
  } else {
    dispatch(characterActions.createCharacter(character));
  }

  dispatch({ type: HERO_ACTIONS.SET_HERO, payload: { hero: character } });

  return character;
};

export const loadCharacter = async (dispatch) => {
  const savedCharacter = localStorage.getItem('character');
  if (!savedCharacter) return null;
  const character = JSON.parse(savedCharacter);
  dispatch(characterActions.updateCharacter(character));
  return character;
};

export const deleteCharacter = async (dispatch) => {
  localStorage.removeItem('character');
  dispatch(characterActions.deleteCharacter());
};
